import React, { Component } from 'react';
import { compose } from 'recompose';
import queryString from 'query-string';
import config from '../../../config';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import { duplicateProject } from '../../Common/Providers/ProjectApi';
import { showErrorMsg } from '../../Common/ErrorMsg'

class ProjectListData extends Component {
  constructor(props) {
    super(props);
    this.index = this.index.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.delete = this.delete.bind(this);
    this.update = this.update.bind(this);
    this.getData = this.getData.bind(this);

    this.shouldCallApi = window.location.pathname.includes('project');
    this.didCallApi = false;

    this.state = {
      isLoaded: false,
      projectList: [],
      lastPage: 1,
      currentPage: 1,
    };
  }

  index(options = {}) {
    const params = queryString.stringify(options);

    return $.get(`${config.pbxApi}/project/list?${params}`);
  }

  duplicate({ id }) {
    this.props.duplicateProject({ id }).done((response) => {
      this.setState((prevState) => {
        const index = prevState.projectList.findIndex((project) => {
          return project.id === id;
        });
        return {
          projectList: [
            ...prevState.projectList.slice(0, index),
            response.data,
            ...prevState.projectList.slice(index)
          ]
        }
      });
    }).fail(() => this.setState({ duplicateFailed: true }));
  }

  delete({ id }) {
    const url = `${config.pbxApi}/project/delete`;
    this.props.showSpinner($.ajax({
      url,
      data: {
        uuid: id
      },
      method: 'DELETE'
    })
      .done((_) => {
        this.setState((prevState) => {
          prevState.projectList.findIndex((project) => {
            return project.id === id;
          });
          return {
            projectList: prevState.projectList.filter(project => project.id !== id)
          }
        });
      })
      .fail(response => {
        const { errors } = response.responseJSON
        showErrorMsg(errors)
      })
    );
  }

  update({ id, ...payload }) {
    const url = `${config.pbxApi}/project/update`;
    this.props.showSpinner($.ajax({
      url,
      data: {
        uuid: id,
        ...payload
      },
      method: 'PUT'
    })
      .done((response) => {
        this.setState((prevState) => {
          const index = prevState.projectList.findIndex((project) => {
            return project.id === id;
          });
          return {
            projectList: [
              ...prevState.projectList.slice(0, index),
              response.data,
              ...prevState.projectList.slice(index + 1)
            ]
          }
        });
      })
      .fail(response => {
        const { errors } = response.responseJSON
        showErrorMsg(errors)
      })
    );
  }

  getData(pageNum) {
    this.setState({
      projectList: [],
      isLoaded: false,
    });
    this.props.showSpinner(
      this.index({ page: pageNum })
        .done((response) => {
          window.scrollTo(0, 0);
          this.setState({
            projectList: response.data.projectList,
            lastPage: response.data.lastPage || 1,
            currentPage: response.data.currentPage || 1,
            isLoaded: true,
          });
        })
        .fail(response => toastr.error(this.props.t("account.project_projectlistdata_getdata_fail", "Something went wrong, please reload later."))));
  }

  componentDidUpdate() {
    this.shouldCallApi = window.location.pathname.includes('project');
    if(this.shouldCallApi && !this.didCallApi){
      this.didCallApi = true;
      this.props.showSpinner(
        this.index({ page: this.state.currentPage })
        .done((response) => {
          this.setState({
            projectList: response.data.projectList,
            lastPage: response.data.lastPage || 1,
            currentPage: response.data.currentPage || 1,
            isLoaded: true,
          });
        }).fail((response) => {
          toastr.error(this.props.t("account.project_projectlistdata_componentdidmount_fail", "Something went wrong, please reload later."));
          this.setState({
            projectList: [],
            isLoaded: false
          });
        })
      );
    }
  }

  render() {
    return this.state.isLoaded && this.props.children(this.state, {
      index: this.index,
      duplicate: this.duplicate,
      delete: this.delete,
      update: this.update,
      getData: this.getData,
    });
  }
}

const enhance = compose(
  withSpinnerOnAjax('duplicateProject', duplicateProject),
);

export const hasProjectListData = (decorator = c => (c)) => {
  const ProjectListDataWithDeco = decorator(enhance(ProjectListData));
  return (WrappedComp) => {
    class HasProjectListData extends Component {
      render() {
        return (
          <ProjectListDataWithDeco t={this.props.t} >
            {(state, methods) => (
              <WrappedComp
                projectListData={state.projectList}
                lastPage={state.lastPage}
                currentPage={state.currentPage}
                {...methods}
                {...this.props}
              />
            )}
          </ProjectListDataWithDeco>
        );
      }
    }
    return HasProjectListData;
  };
};

export default enhance(ProjectListData);
export const undecorated = ProjectListData;



// WEBPACK FOOTER //
// ./src/Account/Project/ProjectListData.js